import { Fade } from "react-awesome-reveal";
import { FaArrowLeft } from "react-icons/fa";
import { PROJECTS } from "../store/projectsData/projectsData";
import { Link } from "react-router-dom";
import CardProject from "../components/CardProject";

export default function AllProjects() {
  return (
    <section className="py-24 bg-dark-slate">
      <div className="container mx-auto">
        <div className="flex items-center justify-between border-b border-solid border-white py-2 text-white text-2xl font-bold">
          <Link to={`/`}>
            <FaArrowLeft />
          </Link>
          <h3>All Projects</h3>

          {/*  */}
        </div>

        <div className="grid grid-cols-auto gap-10 pt-12">
          <Fade>
            {PROJECTS.map((obj) => (
              // ***********************************************************************************************************
              <CardProject key={obj.id} obj={obj} />
              // <div key={obj.id} className="sp-hover-box">
              //   <img
              //     src={obj.photo}
              //     alt="img"
              //     className="object-cover w-full h-full"
              //   />

              //   {/* *********************************************************************************************************** */}
              //   <div className="sp-text">
              //     <h3 className="bg-primary-green font-bold text-xl px-3">
              //       {obj.name}
              //     </h3>

              //     {/* *********************************************************************************************************** */}

              //     <div className="bg-[#ffffffc7] px-3 py-2 ">
              //       {/* *********************************************************************************************************** */}

              //       <p>{obj.desc}</p>

              //       {/* *********************************************************************************************************** */}
              //       <div className="mt-2 flex items-center justify-between text-white">
              //         <Link
              //           to={Boolean(obj.demo) && obj.demo}
              //           target="_blank"
              //           rel="noreferrer"
              //           onClick={(e) => {
              //             if (!Boolean(obj.demo)) e.preventDefault();
              //           }}
              //           className={`
              //             bg-custom-black py-2 px-5 rounded-md gap-2
              //             ${
              //               !Boolean(obj.demo) &&
              //               "opacity-50 cursor-not-allowed pointer-events-none"
              //             }
              //           `}
              //         >
              //           View
              //         </Link>
              //         <Link
              //           to={Boolean(obj.github) && obj.github}
              //           target="_blank"
              //           rel="noreferrer"
              //           onClick={(e) => {
              //             if (!Boolean(obj.github)) e.preventDefault();
              //           }}
              //           className={`
              //            bg-custom-black py-2 px-5 rounded-md gap-2
              //            ${
              //              !Boolean(obj.github) &&
              //              "opacity-50 cursor-not-allowed pointer-events-none"
              //            }
              //          `}
              //         >
              //           Code
              //         </Link>
              //       </div>
              //       {/* *********************************************************************************************************** */}
              //     </div>
              //     {/* *********************************************************************************************************** */}
              //   </div>
              // </div>
            ))}
          </Fade>
        </div>
      </div>
    </section>
  );
}
